<template>
  <modal-template :name="modalName">
    <template slot="header">
      <h2 class="h1">{{ $t("modal.delete_confirm_title") }}</h2>
    </template>
    <template slot="default">
      <p>{{ $t("modal.delete_confirm_text") }}</p>
    </template>
    <template slot="footer">
      <button class="btn--inverted" @click="deleteItem">
        {{ $t("buttons.ok") }}
      </button>
      <button class="btn--inverted" @click="close">
        {{ $t("buttons.back") }}
      </button>
    </template>
  </modal-template>
</template>
<script>
import ModalTemplate from "@/components/modals/ModalTemplate.vue";

export default {
  name: "modal-confirm-deletion",
  components: {
    ModalTemplate,
  },
  data() {
    return {
      modalName: "modal-confirm-deletion",
    };
  },
  methods: {
    close() {
      this.$modal.hide(this.modalName);
    },
    deleteItem() {
      this.$emit("deleteItem");
      this.close();
    },
  },
};
</script>
